import { createFileRoute } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';

import { DataSubscriptions } from '~/components/settings/admin/dataSubscriptions/DataSubscriptions';

export const Route = createFileRoute(
  '/(main)/settings/admin/data-subscriptions/',
)({
  component: DataSubscriptions,
});

export const ADMIN_DATA_SUBSCRIPTIONS = buildRouteExport({
  Route,
});
